import { Inject, Injectable, OnDestroy } from '@angular/core';
import { createBiReporter } from '@itero/observability';
import { isIteroEnvironment, isIteroRegion } from '@itero/client-sd';
import { UNIFIED_PATIENTS_CONFIG, type UnifiedPatientsConfig } from '../services/unified-patients-config.token';

@Injectable({ providedIn: 'root' })
export class UnifiedPatientsBiService implements OnDestroy {
	private biReporter: ReturnType<typeof createBiReporter> | null = null;
	private currentSessionId: string | null = null;

	constructor(@Inject(UNIFIED_PATIENTS_CONFIG) private readonly config: UnifiedPatientsConfig) {}

	ngOnDestroy(): void {
		this.biReporter?.dispose();
		this.biReporter = null;
	}

	get reporter(): ReturnType<typeof createBiReporter> | null {
		const sessionId = this.config.getAppBISessionId();

		if (!sessionId) {
			return null;
		}

		if (this.biReporter && this.currentSessionId === sessionId) {
			return this.biReporter;
		}

		this.biReporter?.dispose();

		const env = this.config.getEnvironment();
		const region = this.config.getRegion();

		if (!env || !region || !isIteroEnvironment(env) || !isIteroRegion(region)) {
			this.biReporter = null;

			return null;
		}

		try {
			this.biReporter = createBiReporter({
				env,
				region,
				// TODO: change to BI_FEATURE once unified-patients is extracted as a standalone MFE
				component: 'rx-app',
				sessionType: this.config.getSessionType(),
				sessionId
			});
			this.currentSessionId = sessionId;
		} catch {
			this.biReporter = null;
		}

		return this.biReporter;
	}
}
